<script>
  import { onMount, onDestroy } from "svelte";
  import { getPosts } from "../getPosts.js";
  import { store } from "../store.js";
  import Select from "svelte-select";
  import { getTerms } from "../getTerms.js";
  import Mode from "./Mode.svelte";

  // Le filtre par lieu

  let reseauItems = [],
    reseauValue,
    public_terms = [],
    public_value;

  onMount(async () => {
    // Les lieux
    let resauJSON = await getTerms("reseau");
    let filteredTerms = resauJSON.map((term) => {
      return {
        value: term.slug,
        label: term.name,
      };
    });
    reseauItems = filteredTerms;

    resauJSON.map((term) => {
      if (term.slug == $store.options[$$props.id].filtresParDefaut.reseau) {
        reseauValue = {
          value: term.slug,
          label: term.name,
        };
      }
    });

    // Les publics
    let publicJSON = await getTerms("public");

    let filteredPublics = publicJSON.map((term) => {
      return {
        value: term.slug,
        label: term.name,
      };
    });
    public_terms = filteredPublics;

    publicJSON.map((term) => {
      if (
        decodeURI(term.slug) ==
        $store.options[$$props.id].filtresParDefaut.public
      ) {
        public_value = {
          value: decodeURI(term.slug),
          label: term.name,
        };
      }
    });

    $store.options[$$props.id].loading = false;
  });

  async function filter_by_location(event) {
    $store.options[$$props.id].loading = true;

    $store.options[$$props.id].filtres.reseau = event.detail.value;

    let params = new URLSearchParams(
      $store.options[$$props.id].filtres
    ).toString();

    let myPosts = await getPosts(params);
    $store.posts[$$props.id] = myPosts;
    $store.options[$$props.id].found_posts = myPosts.found_posts;
    $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
    $store.options[$$props.id].loading = false;
  }

  async function unfilter_locations(event) {
    $store.options[$$props.id].loading = true;

    delete $store.options[$$props.id].filtres.reseau;

    let params = new URLSearchParams(
      $store.options[$$props.id].filtres
    ).toString();

    let myPosts = await getPosts(params);
    $store.posts[$$props.id] = myPosts;
    $store.options[$$props.id].found_posts = myPosts.found_posts;
    $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
    $store.options[$$props.id].loading = false;
  }

  async function filter_by_public(event) {
    $store.options[$$props.id].loading = true;

    $store.options[$$props.id].filtres.public = encodeURI(event.detail.value);

    let params = new URLSearchParams(
      $store.options[$$props.id].filtres
    ).toString();

    let myPosts = await getPosts(params);
    $store.posts[$$props.id] = myPosts;
    $store.options[$$props.id].found_posts = myPosts.found_posts;
    $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
    $store.options[$$props.id].loading = false;
  }

  async function unfilter_public(event) {
    $store.options[$$props.id].loading = true;

    delete $store.options[$$props.id].filtres.public;

    let params = new URLSearchParams(
      $store.options[$$props.id].filtres
    ).toString();

    let myPosts = await getPosts(params);
    $store.posts[$$props.id] = myPosts;
    $store.options[$$props.id].found_posts = myPosts.found_posts;
    $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
    $store.options[$$props.id].loading = false;
  }
</script>

<div class="cs_secondary_filters">
  {#if $store.options[$$props.id].masquer_mode_liste != 1}
    <Mode id={$$props.id} />
  {/if}

  <div class="filter_select filter_by_location">
    <Select
      title="Filtrer par public"
      items={public_terms}
      value={public_value}
      showChevron={true}
      placeholder={"Tous publics"}
      placeholderAlwaysShow={true}
      on:select={filter_by_public}
      on:clear={unfilter_public}
    />
  </div>
  <div class="filter_select filter_by_location">
    <Select
      title="Filtrer par réseau"
      items={reseauItems}
      value={reseauValue}
      showChevron={true}
      placeholder={"Partout"}
      placeholderAlwaysShow={true}
      on:select={filter_by_location}
      on:clear={unfilter_locations}
    />
  </div>
</div>
